import React, { useState, useEffect, useContext } from "react";
import { alertWarningError } from "../../components/Notificaciones";
import { useStyles } from "../../assets/styles/CustomStyles";
import BackdropCustom from "../../components/BackdropCustom";
import { Typography } from "@material-ui/core";
import axios from "../../utils/axios";
import MaterialTable from "material-table";
import Localizacion from "../../components/MaterialTables/Localization";
import TableIcons from "../../components/MaterialTables/TableIcons";
import AccesoDenegado from "../../components/AccesoDenegado";
import UserContext from "../../utils/user/UserContext";

export default function ListaClientes() {

    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState({ content: [] });
    const localization = Localizacion;
    const tableIcons = TableIcons;
    const userContext = useContext(UserContext);

    useEffect(() => {
        if (Number(userContext.state.accesos.administracion) === 1) {
            getClientes()
        }

    }, []);

    const getClientes = async (props) => {
        setIsLoading(true);
        let url = props ? props : "cliente/funListadoGeneral.php";
        try {
            const response = await axios.get(url);

            const clientes = response.data;
            setData({ ...data, content: clientes });

            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            if (error.response) {
                alertWarningError(error.response);
            }
        }
    };

    const title = (
        <Typography variant="body1" display="block">
            LISTA DE CLIENTES
        </Typography>
    );
    const columns = [
        {
            title: "ID",
            field: "id",
            width: "1%",
            hidden: true
        },
        {
            title: "RUC",
            field: "ruc",
            width: "10%",
        },
        {
            title: "Nombre",
            field: "nombre",

        },
        {
            title: "Dirección",
            field: "direccion",
            width: "30%",

        },
        {
            title: "Teléfono",
            field: "telefono",
            width: "10%",
        },

    ];

    const options = {
        filtering: false,
        exportButton: false,
        exportAllData: false,
        headerStyle: { position: "sticky", top: 0 },
        maxBodyHeight: "65vh",
        paging: true,
        draggable: false,
        rowStyle: {
            fontSize: "small",
        },
    };

    return (
        <>
            {Number(userContext.state.accesos.administracion) === 1 ?
                <MaterialTable
                    title={title}
                    columns={columns}
                    data={data.content}
                    options={options}
                    isLoading={isLoading}
                    componentsAssets={{ classes }}
                    localization={localization}
                    icons={tableIcons}
                    editable={{
                        onRowAdd: async (newData) => {
                            const dataNew = [...data.content];
                            console.log(newData)
                            try {

                                const response = await axios({
                                    method: "POST",
                                    url: "cliente/funAgregar.php",
                                    data: newData,
                                });
                                let status = response.status

                                if (status === 200) {
                                    dataNew.push(newData)
                                    setData({ ...data, content: dataNew });
                                }

                            } catch (error) {
                                if (error.response) {
                                    alertWarningError(error.response);
                                }
                            }
                        },
                        onRowUpdate: async (newData, oldData) => {
                            console.log(newData)
                            const dataUpdate = [...data.content];
                            const index = oldData.tableData.id;

                            try {

                                const response = await axios({
                                    method: "POST",
                                    url: "cliente/funModificar.php",
                                    data: newData,
                                });
                                let status = response.status

                                if (status === 200) {
                                    dataUpdate[index] = newData;
                                    setData({ ...data, content: dataUpdate });

                                }

                            } catch (error) {
                                if (error.response) {
                                    alertWarningError(error.response);
                                }
                            }
                        },

                        onRowDelete: async (oldData) => {
                            const listaArticulo = [...data.content];
                            const index = oldData.tableData.id;
                            try {
                                let idcliente = listaArticulo[index];

                                const response = await axios.delete(`/cliente/funEliminar.php?id=` + Number(idcliente.id))
                                let status = response.status

                                if (status === 200) {
                                    listaArticulo.splice(index, 1);

                                    setData({ ...data, content: listaArticulo });
                                }

                            } catch (error) {
                                if (error.response) {
                                    alertWarningError(error.response);
                                }
                            }

                        },
                    }}
                />
                : <AccesoDenegado />}
        </>
    );
}
